export const COLOR_CHOICES = [
  "#FF00FF",
  "#8622FF",
  "#FE0056",
  "#00FFCE",
  "#FF8000",
  "#00B7EB",
  "#FFFF00",
  "#0E7AFE",
  "#FFABAB",
  "#0000FF",
  "#CCCCCC",
];

export const FILL_COLOR = "rgba(0,0,0,0.35)";

export const RADIANS_PER_45_DEGREES = Math.PI / 4;

export const SCALE_SPEED = 0.01;

export const DEFAULT_SCALE_FACTOR = 0.69;
export const MIN_SCALE_FACTOR = 0.1;
export const MAX_SCALE_FACTOR = 1;

export const GRAB_RADIUS = 10;
export const NODE_RADIUS = 5;
export const LINE_WIDTH = 2;

export const DRAW_MODES = {
  POLYGON: "polygon",
  LINE: "line",
  LINE_CROSSING: "line_crossing",
  EDIT: "edit",
};

export const ZONE_TYPES = {
  ROI_FILTERING: "roi_filtering",
  OVERCROWDING: "overcrowding",
  LINE_CROSSING: "line_crossing",
  DIRECTION_DETECTION: "direction_detection",
};

export const ZONE_TYPE_LABELS = {
  [ZONE_TYPES.ROI_FILTERING]: "ROI Filtering",
  [ZONE_TYPES.OVERCROWDING]: "Overcrowding Detection",
  [ZONE_TYPES.LINE_CROSSING]: "Line Crossing",
  [ZONE_TYPES.DIRECTION_DETECTION]: "Direction Detection",
};

export const ZONE_TYPE_COLORS = {
  [ZONE_TYPES.ROI_FILTERING]: "#00FFCE",
  [ZONE_TYPES.OVERCROWDING]: "#FE0056",
  [ZONE_TYPES.LINE_CROSSING]: "#FF8000",
  [ZONE_TYPES.DIRECTION_DETECTION]: "#8622FF",
};

export const ZONE_TYPE_DRAW_MODES = {
  [ZONE_TYPES.ROI_FILTERING]: DRAW_MODES.POLYGON,
  [ZONE_TYPES.OVERCROWDING]: DRAW_MODES.POLYGON,
  [ZONE_TYPES.LINE_CROSSING]: DRAW_MODES.LINE_CROSSING,
  [ZONE_TYPES.DIRECTION_DETECTION]: DRAW_MODES.LINE,
};

export const ZONE_TYPE_DESCRIPTIONS = {
  [ZONE_TYPES.ROI_FILTERING]:
    "Draw a polygon area to filter objects within the region",
  [ZONE_TYPES.OVERCROWDING]: "Draw a polygon area to detect overcrowding",
  [ZONE_TYPES.LINE_CROSSING]:
    "Draw two lines: first for direction, then for crossing detection",
  [ZONE_TYPES.DIRECTION_DETECTION]:
    "Draw a line to detect object movement direction",
};

export const SUPPORTED_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
];

export const DEFAULT_IMAGE_URL =
  "https://assets.website-files.com/5f6bc60e665f54545a1e52a5/63d3f236a6f0dae14cdf0063_drag-image-here.png";

export const LINE_CROSSING_STEPS = {
  DIRECTION: "direction",
  CROSSING: "crossing",
  COMPLETE: "complete",
};

export const LINE_CROSSING_STEP_DESCRIPTIONS = {
  [LINE_CROSSING_STEPS.DIRECTION]:
    "Draw the direction line (shows expected movement direction)",
  [LINE_CROSSING_STEPS.CROSSING]:
    "Draw the crossing line (the actual detection line)",
  [LINE_CROSSING_STEPS.COMPLETE]: "Line crossing zone complete",
};

export const LINE_CROSSING_COLORS = {
  [LINE_CROSSING_STEPS.DIRECTION]: "#FFD700", // Gold for direction line
  [LINE_CROSSING_STEPS.CROSSING]: "#FF8000", // Orange for crossing line
};
